import { Container, Divider } from "@material-ui/core";
import { Box, Grid, styled, Typography } from "@mui/material";
import axios from "axios";
import {
  CurrencyDisplay,
  CustomTable,
  FormLabel,
  ModalError,
  ModalSuccess,
  ModalWarning,
  Page,
  PrimaryButton,
  SectionLabel,
  SkeletonComponent,
  StatusChip,
  TextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors, textCapitalization, wordCapitalize } from "utils";
import ModalUploadPayment from "../Components/ModalUploadPayment";

const DetailLoan = props => {
  const classes = globalStyles();
  const history = useHistory();
  const { id } = useParams();
  const { state } = useLocation();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [pageDetail, setPageDetail] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const loanStatus = pageDetail?.status;
  const statusWaiting = loanStatus === "waiting_for_approval";
  const statusApproved = loanStatus === "approved";
  const statusActive = loanStatus === "active";

  const handleApproval = status => {
    ModalWarning(
      `Are you sure to ${status} this loan request ?`,
      `${wordCapitalize(status)} Loan Request`
    ).then(res => res?.isConfirmed && submitApproval(status));
  };

  const getDetail = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction/detail/${id}`,
        { headers }
      );
      setPageDetail(res?.data?.data);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const submitApproval = async value => {
    const formData = new FormData();
    formData.append("status", value === "approve" ? "approved" : "rejected");
    try {
      setLoadingPage(true);
      await axios.put(`${hardBaseUrl}/transaction/proof/${id}`, formData, {
        headers,
      });
      ModalSuccess(`Successfully ${value} loan`).then(() => history.goBack());
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const handleUpload = async documents => {
    const formData = new FormData();
    formData.append("status", "active");
    documents.map(item => {
      formData.append("file_name", item);
    });
    try {
      setLoadingButton(true);
      await axios.put(`${hardBaseUrl}/transaction/proof/${id}`, formData, {
        headers,
      });
      ModalSuccess("Successfully upload payment proof").then(() =>
        history.goBack()
      );
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setModalVisible(false);
      setLoadingButton(false);
    }
  };
  useEffect(() => {
    getDetail();
  }, []);

  return (
    <Page className={classes.root} title="Detail Loan">
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title="Loan Transaction"
            breadcrumbData={breadcrumbData}
            backButton
          />
          <Divider className={classes.divider} />
          <Grid container justifyContent="space-between">
            <Grid item>
              <SectionLabel
                title="Loan Detail"
                subTitle="View details of the loan."
              />
            </Grid>
            <Grid item>
              <StatusChip
                label={
                  statusWaiting
                    ? "Waiting for Approval"
                    : textCapitalization(pageDetail?.status)
                }
                type={typeChip[pageDetail?.status]}
              />
            </Grid>
          </Grid>
          <Box border="1px solid #ebebeb" borderRadius="5px" p="24px" my="16px">
            <Grid container>
              <Grid item xs={6}>
                <img
                  src={pageDetail?.publisher?.profile_image}
                  alt="img"
                  height={80}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography14 textAlign="right">
                  {pageDetail?.publisher?.address}
                </Typography14>
              </Grid>
            </Grid>
            <Divider className={classes?.divider} />
            <Grid container>
              <Grid item xs={6}>
                <Typography14>Give Loan to:</Typography14>
                <FormLabel label={pageDetail?.composer_name} />
              </Grid>
              <Grid item xs={6}>
                {formLoanDetail?.map((item, index) => (
                  <Grid key={index} container justifyContent="space-between">
                    <Grid item>{item?.label}:</Grid>
                    <Grid item>
                      {item?.value === "revenue" ? (
                        <CurrencyDisplay
                          prefix="Rp "
                          value={pageDetail?.[item?.value]}
                          decimalScale={2}
                          suffix=",-"
                        />
                      ) : item?.value === "tenor" ? (
                        `${state?.customer?.tenor}`
                      ) : (
                        pageDetail?.[item?.value]
                      )}
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Divider className={classes?.divider} />
            <FormLabel label="Notes:" />
            {pageDetail?.status === "active" ? (
              <TextInput
                placeholder="Notes"
                value={pageDetail?.note}
                onChange={e =>
                  setPageDetail(currentState => ({
                    ...currentState,
                    note: e?.target?.value,
                  }))
                }
                width="30%"
                multiline
                rows={4}
              />
            ) : (
              <Typography14>{pageDetail?.note}</Typography14>
            )}
            <Grid container my={2}>
              <Grid item xs={12}>
                <CustomTable
                  columnTable={columnTableDetail}
                  data={dataTableDetail}
                />
              </Grid>
            </Grid>
            <Grid container justifyContent="right">
              <Grid item>
                <Typography14 textAlign="right">Total Loan:</Typography14>
                <Typography fontSize={24} fontWeight={600}>
                  <CurrencyDisplay
                    prefix="Rp "
                    value={pageDetail?.revenue}
                    decimalScale={2}
                    suffix=",-"
                  />
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {props.rolesFor === "finance" && (statusApproved || statusWaiting) && (
            <Grid container justifyContent="right" columnSpacing={1}>
              {statusWaiting && (
                <Grid item>
                  <PrimaryButton
                    label="Reject"
                    onClick={() => handleApproval("reject")}
                    color="#FF3E00"
                  />
                </Grid>
              )}
              <Grid item>
                <PrimaryButton
                  label={statusApproved ? "Confirm" : "Approve"}
                  onClick={() =>
                    statusApproved
                      ? setModalVisible(true)
                      : handleApproval("approve")
                  }
                />
              </Grid>
            </Grid>
          )}
          {props.rolesFor === "finance" && statusActive && (
            <CustomTable columnTable={columnTable} />
          )}
        </Container>
      )}
      <ModalUploadPayment
        open={modalVisible}
        onClose={() => setModalVisible(false)}
        loadingButton={loadingButton}
        onSubmit={handleUpload}
      />
    </Page>
  );
};

const Typography14 = styled(Typography)({
  fontSize: 14,
});
const breadcrumbData = [
  {
    label: "Transaction",
    link: "/admin/loan",
  },
  {
    label: "Loan",
    link: "/admin/loan",
  },
  {
    label: "Detail Loan",
    active: true,
  },
];
const typeChip = {
  active: "active",
  approved: "success",
  paid: "success",
  waiting_for_approval: "warning",
  rejected: "danger",
};
const formLoanDetail = [
  { label: "Date", value: "invoice_date" },
  { label: "Composer/Author", value: "composer_name" },
  { label: "Tenor", value: "tenor" },
  { label: "Loan Value", value: "revenue" },
];

const columnTableDetail = [
  {
    name: "date",
    title: "Date",
    renderText: item => item || "-",
  },
  {
    name: "transaction",
    title: "Transaction",
    renderText: item => item || "-",
  },
  {
    name: "period",
    title: "Period",
    renderText: item => item || "-",
  },
  {
    name: "history",
    title: "History",
    renderText: item => {
      const isNegative = item?.includes("-");
      return (
        <Box
          bgcolor={isNegative ? "#FFE9E9" : "#ECFCF2"}
          border={`1px solid ${isNegative ? "#FF3E00" : "#27AE60"}`}
          borderRadius="20px"
        >
          <Typography
            color={isNegative ? "#FF3E00" : "#27AE60"}
            fontSize={12}
            textAlign="center"
            fontWeight={600}
          >
            {item}
          </Typography>
        </Box>
      );
    },
  },
  {
    name: "balance",
    title: "Balance",
    renderText: item => item || "-",
  },
];

const dataTableDetail = [
  {
    date: "23 January 2026",
    transaction: "Payment",
    period: "01 January 2026 - 30 June 2026",
    history: "- Rp50,434.92",
    balance: "Rp422,065.08",
  },
  {
    date: "01 January 2026",
    transaction: "Loan",
    period: "01 January 2026 - 30 June 2026",
    history: "+ Rp472,500.00",
    balance: "Rp472,500.00",
  },
];

const columnTable = [
  {
    name: "nik",
    title: "Installment Number",
    renderText: item => item || "-",
  },
  {
    name: "nik",
    title: "Due Date",
    renderText: item => item || "-",
  },
  {
    name: "nik",
    title: "Installment Value",
    renderText: item => item || "-",
  },
  {
    name: "nik",
    title: "Status",
    renderText: item => item || "-",
  },
  {
    name: "nik",
    title: "Action",
    renderText: item => item || "-",
  },
];

export default DetailLoan;
